<template>
  <form v-on:submit="save">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-info">
          <div class="card-header with-border">
            <h3 class="card-title">Department Coordinator</h3>
          </div>
          <!-- /.box-header -->
          <!-- form start -->
          <div class="card-body">
            <div class="row" style="margin-top: 10px">
              <div class="col-md-6">
                <label>Program *</label>
                <select class="form-control" v-model="ProgramID" v-on:change="loadSession()" required>
                  <option value="0">--Select Program--</option>
                  <option v-for="item in program" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Session *</label>
                <select class="form-control" v-model="SessionID" required>
                  <option value="0">--Select Session--</option>
                  <option v-for="item in session" v-bind:value="item.SessionID">{{item.Name}}</option>
                </select>
              </div>
            </div>
          </div>
          <hr />
          <!--Button -->
          <div class="card-footer">
            <button class="btn btn-success float-right" style="width: 120px" type="button" v-on:click="loadStudents()">Load Students</button>
            <button class="btn btn-info float-right" v-show="grid === 'show'" style="width: 120px;margin-right: 5px;" type="submit">Save</button>
            <button class="btn btn-danger" style="width: 120px" type="button" v-on:click="clear()">Cancel</button>
          </div>
        </div>
        <div class="card card-info"  v-show="grid === 'show'">
          <div class="card-header with-border">
            <h3 class="card-title">Comprehensive Exam</h3>
            <!--<%--<button type="button" class="btn btn-primary" style="float: right" v-on:click="changestate()">+Add New</button>--%>-->
          </div>
          <!-- /.box-header -->
          <!-- form start -->
          <div class=" card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-bordered table-sm">
                    <thead class="bg-info">
                      <tr>
                        <th>Sr. No.</th>
                        <th>Name</th>
                        <th>Roll no</th>
                        <th>Exam Pass</th>
                        <th>Date</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, ind) in student">
                        <td>{{ind+1}}</td>
                        <td>{{item.Name}}</td>
                        <td>{{item.RollNo}}</td>
                        <td>
                          <select class="form-control" v-model="item.Status">
                            <option v-bind:value="true">Yes</option>
                            <option v-bind:value="false">No</option>
                          </select>
                        </td>
                        <td>
                          <input class="form-control" type="date" v-model="item.Date" required/>
                        </td>
                        <td>
                          <input class="form-control" v-model="item.Remarks" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
    const axios = require('axios').default;

  export default ({
    data() {
      return {
        session: [],
        program: [],
        ProgramID: 0,
        SessionID: 0,
        student: [],
        grid: 'hide',
      }
    },
    created: function () {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        axios.post('/api/DCApi/loadComprehensiveProgram')
          .then(function (response) {
            vm.program = response.data.prog;
          })
      },
      clear() {
        window.location.reload();
      },
      loadSession() {
        var vm = this;
        vm.SessionID = 0;
        axios.post('/api/DCApi/loadSessionComprehensiveExam?ID=' + vm.ProgramID)
          .then(function (response) {
            vm.session = response.data.sess;
          })
      },

      loadStudents() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/loadStudentsComprehensiveExam?sessID=' + vm.SessionID + '&progID=' + vm.ProgramID)
          .then(function (response) {
            vm.student = response.data.lst;
            vm.grid = "show";
            endReq();
          })
      },

      save(e) {
        e.preventDefault();
        for (var i = 0; i < this.student.length; i++) {
          if (this.student[i].Status == true && this.student[i].Date == "") {
            toastr.error("Date is Required of " + this.student[i].Name);
            return;
          }

        }
        if (this.student.length == 0) {
          toastr.error("No Student Selected");
          return
        }
        startReq();
        var vm = this;
        axios.post('/api/DCApi/saveComprehensiveExam', {
          lst: vm.student,
        })
          .then(function (response) {
            if (response.data.status) {
              toastr.success("Data Saved");
              vm.grid = "hide";
              endReq();
            }
           
          })
      },
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/comprehensiveExam.vue